import {Domain} from './domain';
import {Recipient} from './recipient';

export interface RecipientUser {
  createdBy: string;
  updatedBy: string;
  id: number;
  email: string;
  name: string;
  phone: string;
  profilePhoto: string;
  birthAt: string;
  role: string;
  createdAt: string;
  updatedAt: string;
  domain: Domain;
  password?: string;
  invitationToken?: string;
  resetToken?: string;
  status: UserStatus;
  recipient: Recipient;
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  BLOCKED = 'blocked',
}

export interface SessionUser {
  id?: number;
  email: string;
  origin: string;
  name: string;
  document: string;
  companyName?: string;
  companyDocument?: string;
  profilePhoto: string;
}
